<script>
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox'
import InputRadio from '@/components/atoms/inputlib/components/InputRadio'
import InputStep from '@/components/molecules/input/InputStep'

export default {
    name: 'MealOption',
    components: {
        InputStep,
        InputRadio,
        InputCheckbox,
    },
    props: {
        model: null,
        selectOne: Boolean,
        selectMultipleEachOne: Boolean,
        optional: Boolean,
        disabled: Boolean,
        disableAdd: Boolean,
        noPrice: Boolean,
        value: null,
        currency: null,
        available: undefined,
        max: undefined,
        min: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            quantity: 0,
        }
    },
    computed: {
        setQuantity() {
            return this.value && this.model && this.max !== null
                ? this.max !== 1 &&
                      (this.selectOne
                          ? this.value.id === this.model.id
                          : this.value.find((result) => result.id === this.model.id))
                : false
        },
        selected() {
            return this.selectOne
                ? this.value.id === this.model.id
                : !!this.value?.find((val) => val.id === this.model.id)
        },
        maxQuantity() {
            return this.available >= 0 && this.quantity < this.max && this.available < this.max
                ? this.quantity + this.available
                : this.max
        },
        hasNoneAboveAllergen() {
            return this.model?.allergens?.indexOf('non_above') > -1
        },
        hasAllergens() {
            if (this.hasNoneAboveAllergen) {
                return false
            }
            return this.model?.allergens?.length
        },
        hasSuitableInfo() {
            return this.model?.suitable_for?.length
        },
        hasAddtitional() {
            return this.model?.additional?.length
        },
        needLine() {
            return (
                (this.model?.description || this.model.kcal) &&
                (this.hasAllergens || this.hasAddtitional)
            )
        },
        disableInput() {
            return (
                (this.disableAdd && !this.selected && this.selectMultipleEachOne) || this.disabled
            )
        },
    },
    mounted() {
        if (this.min && this.min > 1) this.quantity = this.min
        if (!this.selectOne) this.$emit('input', [])
    },
    methods: {
        onSelect(val) {
            if (this.selectOne) {
                if (this.value?.id === val.id) val = null
                if (val) {
                    val.quantity = this.quantity || 1
                    this.quantity = val.quantity
                } else this.quantity = 0
            } else {
                let index = val?.findIndex((option) => option.id === this.model.id)

                if (index > -1) {
                    val[index].quantity = this.quantity || 1
                    this.quantity = val[index].quantity
                } else this.quantity = 0
            }
            this.$emit('input', val)
        },
        selectMealOption(model, quantity) {
            if (this.selectOne) {
                this.$emit('input', quantity ? { ...model, ...{ quantity: quantity } } : null)
            } else {
                let result = JSON.parse(JSON.stringify(this.value))
                let index = result.findIndex((val) => val.id === model.id)
                if (index > -1) {
                    if (quantity) result[index].quantity = quantity
                    else result.splice(index, 1)
                } else if (quantity) {
                    result.push({ ...model, ...{ quantity: quantity } })
                }
                this.$emit('input', result)
            }
        },
        clickOnRow() {
            if (
                !(this.selectOne || this.selectMultipleEachOne) &&
                !this.disabled &&
                !this.disableAdd
            ) {
                this.$refs.step?.inc()
            } else this.$refs.input?.toggle()
        },
    },
}
</script>

<template lang="pug">
.meal-option.cursor-pointer.select-none.p-3(@click="clickOnRow")
    component.font-size-base.mw-100.relative(
        v-if="selectOne || selectMultipleEachOne"
        ref="input"
        :value="value"
        @input="onSelect"
        :data="model"
        track-by="id"
        :disabled="disableInput"
        :is="selectOne ? 'input-radio' : 'input-checkbox'")
    input-step.mb-0(
        v-else
        ref="step"
        v-model="quantity"
        :disabled="disabled"
        @input="selectMealOption(model, $event)"
        @click.stop.prevent.native
        :max="maxQuantity" :min="min"
        :disableAdd="disableAdd"
        popover-container="#select-meal"
        removable xxs variant dynamic)
    .meal-option-grid(:class="{'position-relative top--fix-4': !selectOne && !selectMultipleEachOne }")
        label.text-26.font-weight-normal.mb-0.line-1.font-size-base {{ model.name }}
        .d-inline-flex.align-items-center.justify-between.ml-auto
            .meal-price(v-if="!noPrice")
                span.line-1(v-if="model.price && currency" :class="{'text-primary': model.original_price}") +{{model.price  | toCurrency(currency.locale, currency.currency_code)}}
                    s.text-73.ml-3.line-1(v-if="model.original_price") +{{model.original_price | toCurrency(currency.locale, currency.currency_code)}}
        .meal-option-desc.mt-2
            p.body-sm.content-html.mb-0.line-1.font-size-md(v-if="model.description" v-html="model.description")
            div.body-sm.mb-0.font-size-xs.mt-3.line-1.text-primary-0(v-if="hasSuitableInfo")
              span.body-sm.mb-0.font-size-xs.line-1.bullet(v-for="diet in model.suitable_for") {{$t(`diet.${diet}`)}}
            div.body-sm.mb-0.font-size-xs.mt-3.line-1(v-if="model.kcal") {{model.kcal | toCal}}
            hr.mb-4.mt-3(v-if="needLine")
            div.body-sm.mb-0.font-size-xs.mt-3.line-1(v-if="hasAllergens") {{$t('allergen.label')}}: &nbsp;
              span.body-sm.mb-0.font-size-xs.line-1.comma(v-if="hasAllergens" v-for="allergen in model.allergens") {{$t(`allergen.${allergen}`)}}
            div.body-sm.mb-0.font-size-xs.mt-3.line-1(v-if="hasAddtitional")
              span.body-sm.mb-0.font-size-xs.line-1.bullet(v-for="additional in model.additional") {{$t(`additional.${additional}`)}}

</template>
